import Constants from 'Constants'
import Common from '@/assets/js/common.js'

let ModelMixin = {
	methods: {
	}
}

export default ModelMixin
